import { mount, type MountOptions } from './mount.js';

/**
 * Standalone entry. Read configuration from the URL query string so an
 * iframe boot needs zero JS glue from the host:
 *
 *   /?agentId=agent-001                         → boot directly into the dashboard
 *   /?agentId=a-1&token=xyz                     → with opaque host token
 *   /?parentOrigin=https://portal.losan.com     → enable postMessage bridge
 *                                                  (validated against this origin)
 */
const params = new URLSearchParams(window.location.search);
const agentId = params.get('agentId');
const token = params.get('token');
const parentOrigin = params.get('parentOrigin');

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element');

const identity = agentId
  ? token
    ? { agentId, role: 'agent' as const, token }
    : { agentId, role: 'agent' as const }
  : null;

const opts: MountOptions = { identity };
// Only enable the bridge when actually inside an iframe AND given an origin.
if (parentOrigin && window.parent !== window) {
  opts.postMessage = { allowedOrigin: parentOrigin };
}

mount(root, opts);
